export default "__VITE_ASSET__Otw96mOua4$0Kwg7klCs0Q__"